// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._1bsb1tcg{width:24px}
._1bsb7vkz{width:1pc}
._1bsbckbl{width:3pc}
._1bsbzwfg{width:2pc}
._1reo15vq{overflow-x:hidden}
._4t3i1tcg{height:24px}
._4t3i7vkz{height:1pc}
._4t3ickbl{height:3pc}
._4t3izwfg{height:2pc}
._lcxvglyw{pointer-events:none}
._lswuvuon{fill:var(--ds-surface,#fff)}
._vc881r31 stop{stop-color:currentColor}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/icon/dist/esm/components/svg.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,UAAU;AACrB,WAAW,SAAS;AACpB,WAAW,SAAS;AACpB,WAAW,SAAS;AACpB,WAAW,iBAAiB;AAC5B,WAAW,WAAW;AACtB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,mBAAmB;AAC9B,WAAW,2BAA2B;AACtC,gBAAgB,uBAAuB","sourcesContent":["._18m915vq{overflow-y:hidden}\n._1bsb1tcg{width:24px}\n._1bsb7vkz{width:1pc}\n._1bsbckbl{width:3pc}\n._1bsbzwfg{width:2pc}\n._1reo15vq{overflow-x:hidden}\n._4t3i1tcg{height:24px}\n._4t3i7vkz{height:1pc}\n._4t3ickbl{height:3pc}\n._4t3izwfg{height:2pc}\n._lcxvglyw{pointer-events:none}\n._lswuvuon{fill:var(--ds-surface,#fff)}\n._vc881r31 stop{stop-color:currentColor}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
